// frontend/src/pages/admin/cre/components/ConfirmApproveModal.jsx
import { FiAlertTriangle, FiCheck, FiX } from 'react-icons/fi';

export default function ConfirmApproveModal({ open, proposal, onClose, onConfirm }) {
  if (!open || !proposal) return null;
  const op = proposal.operation;
  const tableLbl = proposal.target_table;

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
        <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-200">
          <FiAlertTriangle className="h-4 w-4 text-orange-500" />
          <h3 className="text-sm font-semibold text-gray-800">Confirmer l'application</h3>
        </div>

        <div className="p-4 space-y-3 text-[12px] text-gray-700">
          <p>
            Cette action va appliquer la modification suivante directement en base de données
            (calculs TURPE → factures clients). <strong>Cette opération est difficilement réversible.</strong>
          </p>

          <div className="bg-gray-50 border border-gray-200 rounded p-2 space-y-1 text-[11px]">
            <div>
              <span className="text-gray-500">Opération :</span>{' '}
              <span className={`px-1.5 py-0.5 rounded font-semibold ${
                op === 'INSERT' ? 'bg-green-100 text-green-800' : 'bg-orange-100 text-orange-800'
              }`}>{op}</span>
            </div>
            <div>
              <span className="text-gray-500">Table cible :</span>{' '}
              <span className="font-mono">{tableLbl}</span>
            </div>
            <div>
              <span className="text-gray-500">Détail :</span>{' '}
              <span className="text-gray-700">{proposal.diff_preview || '—'}</span>
            </div>
          </div>

          <details className="text-[10px] text-gray-500">
            <summary className="cursor-pointer hover:text-gray-700">Voir le payload JSON complet</summary>
            <pre className="mt-2 bg-gray-50 p-2 rounded max-h-48 overflow-auto">
              {JSON.stringify(proposal.proposed_row, null, 2)}
            </pre>
            {proposal.current_row && (
              <>
                <div className="text-gray-600 mt-2">Ligne actuelle remplacée :</div>
                <pre className="mt-1 bg-gray-50 p-2 rounded max-h-32 overflow-auto">
                  {JSON.stringify(proposal.current_row, null, 2)}
                </pre>
              </>
            )}
          </details>
        </div>

        <div className="flex justify-end gap-2 px-4 py-3 border-t border-gray-200">
          <button onClick={onClose}
            className="inline-flex items-center gap-1 px-3 py-1.5 text-[11px] rounded border border-gray-300 hover:bg-gray-50">
            <FiX className="h-3.5 w-3.5" /> Annuler
          </button>
          <button onClick={() => onConfirm(proposal.id)}
            className="inline-flex items-center gap-1 px-3 py-1.5 text-[11px] font-semibold rounded bg-green-600 text-white hover:bg-green-700">
            <FiCheck className="h-3.5 w-3.5" /> Confirmer l'application
          </button>
        </div>
      </div>
    </div>
  );
}
